/**
 * WHAT: PostgreSQL password policy compliance wrapper component.
 * WHY: PostgreSQL lacks built-in password profiles, so this delegates to a dedicated
 *      PostgresqlPasswordSecurity component focused on role security attributes,
 *      password expiration, and best practices rather than the generic compliance view.
 */

import React from 'react';
import PostgresqlPasswordSecurity from './PostgresqlPasswordSecurity';

/**
 * WHAT: Thin wrapper that delegates to PostgresqlPasswordSecurity for password compliance.
 * WHY: PostgreSQL lacks built-in password profiles, so it uses a dedicated security component
 *      instead of the generic PasswordPolicyCompliance used by Oracle/MSSQL/MySQL.
 */
const PostgresqlPasswordCompliance = () => {
  return <PostgresqlPasswordSecurity />;
};

export default PostgresqlPasswordCompliance;
